import { Box, Skeleton } from '@mui/material';
import { forwardRef } from 'react';

const CARD_WIDTH = 1280;
const CARD_HEIGHT = 804;

type CardImageProps = {
  size: number;
  color: string;
  image: string | null | undefined;
  loading?: boolean;
};

export const CardImage = forwardRef<HTMLDivElement, CardImageProps>(function CardImage(
  { size, image, color, loading },
  ref,
) {
  const width = size;
  const height = (CARD_HEIGHT / CARD_WIDTH) * size;
  return loading ? (
    <Skeleton ref={ref} variant="rounded" width={width} height={height} />
  ) : (
    <Box
      ref={ref}
      sx={[
        {
          borderRadius: 1,
          backgroundColor: color,
          backgroundSize: 'cover',
          width: size,
          height: (CARD_HEIGHT / CARD_WIDTH) * size,
        },
        image
          ? {
              backgroundImage: `url(${image})`,
            }
          : {
              backgroundImage: null,
            },
      ]}
    />
  );
});
